import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserStore } from '../services/user-store.service';

/** El muelle lo ve el admin y el lider. El resto va a Mi cuenta. */
export const muelleGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (userStore.isAdmin() || userStore.isLider()) {
    return true;
  }

  return router.createUrlTree(['/configuracion', 'mi-cuenta']);
};
